// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"05a286c4","519":"0c011099","681":"d88a567c","848":"548f1332","900":"b85231b8"}[chunkId] + ".chunk.css";
};